"use client";

import { useTranslations } from "@frontend/lib/next-intl-typed";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useInsuranceConnectorSend } from "../insurance-connector-provider";

/**
 * Parent/guardian consent intake form. Only reachable when an org has the
 * minor-consent-referral config flag enabled, which today is Rappore alone.
 */
const CONSENT_FORM_URL = "https://rappore.typeform.com/to/SEfaup9q";

/**
 * Shown instead of the flat age rejection when a 15, 16 or 17 year old reaches
 * the end of the eligibility questions. They cannot book here, so the only
 * way forward is the consent form.
 */
export function EligibilityMinorConsentReferral() {
  const t = useTranslations("InsuranceConnector");
  const send = useInsuranceConnectorSend();

  return (
    <div className="flex flex-col justify-between h-full pt-2 md:pt-[48px]">
      <div className="space-y-6">
        <h2 className="text-[28px] md:text-4xl leading-[110%] tracking-[-0.02em] font-semibold">
          {t.rich("MinorConsentReferral", {
            form: (chunks) => (
              <a
                href={CONSENT_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00A3FF] underline decoration-1 underline-offset-4"
              >
                {chunks}
              </a>
            ),
          })}
        </h2>
        <a
          href={CONSENT_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xl md:text-2xl font-semibold text-[#00A3FF] underline decoration-2 underline-offset-4"
        >
          {t("MinorConsentReferralLinkLabel")}
          <ArrowUpRight className="w-6 h-6" aria-hidden="true" />
        </a>
      </div>

      <div className="flex justify-end mt-6">
        <motion.button
          type="button"
          onClick={() => send({ type: "DISMISS" })}
          className="rounded-full font-medium text-white px-[53px] md:px-[48px] py-5 md:py-[20px] text-base md:text-xl md:w-auto"
          initial={{ backgroundColor: "#000000" }}
          whileHover={{ backgroundColor: "#00A3FF" }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          {t("Dismiss")}
        </motion.button>
      </div>
    </div>
  );
}
